module.exports = __webpack_public_path__ + "static/media/towing_services_ld.39d0fbce.png";